e4.cart = {
    init: function () {
        if ( jQuery( '.js-e-cart-form' ).length === 1 ) {
            e4.cart.event = e4.util.registerEvents( 'load loaded update updated productadd productadded productremove productremoved orderlinedelete orderlinedeleted orderlineincrease orderlinedecrease', 'cart' );
            e4.cart.saveInternalBackLink();
            e4.cart.bindEvents();
            e4.cart.orderline.bindEvents();
        }
        else if ( jQuery( '.js-e-cart-quantity' ).length > 0 ) {
            e4.cart.event = e4.util.registerEvents( 'productadd productadded productremove productremoved', 'cart' );
        }
        e4.cart.updateQuantityInfo();
        e4.cart.msg.init();
    },
    bindEvents: function () {

        jQuery( document ).on( 'click', '.js-e-cart-back-link', e4.cart.goToInternalBackLink ).find( '.js-e-cart-form' ).on( 'submit', function ( event ) {
            event.preventDefault();
        } );

        jQuery( '.js-e-cart' ).on( 'change', '.js-alcadon-cart-no-partial-delivery-requested-checkbox', function ( event ) {
            e4.cart.setNoPartialDeliveryValue( event.target );
        } ).find( '.js-alcadon-cart-no-partial-delivery-requested-checkbox' ).trigger( 'change' );
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        // TODO: Refactor to use e4.util.ajax
        var jCart = jQuery( '.js-e-cart' ),
            jqXHR = jQuery.ajax( jQuery.extend( {
                url: e4.settings.ecom.cart.url,
                method: 'POST',
                dataType: 'json',
                cache: false,
                beforeSend: function () {
                    if ( jCart.length === 1 ) {
                        jQuery( '.js-e-cart-main, .js-e-cart-aside' ).find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                    }
                }
            }, objAjaxSettings ) );
        jqXHR.done( function ( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
            if ( jCart.length === 1 ) {
                jQuery( '.js-e-cart-main, .js-e-cart-aside' ).find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
            }
        } );
        return jqXHR;
    },

    setNoPartialDeliveryValue: function ( domNode ) {
        var jInputCheckbox = jQuery( domNode ),
            jInputHidden = jQuery( '.js-alcadon-cart-no-partial-delivery-requested-input' );
        jInputHidden.val( jInputCheckbox.prop( 'checked' ) );
        e4.cart.ajax( {
            beforeSend: null,
            data: jQuery( '.js-alcadon-cart-top-actions-form' ).serialize()
        } );
    },

    saveInternalBackLink: function () {
        if ( document.referrer.indexOf( location.protocol + '//' + location.host ) === 0 && document.referrer.indexOf( '/shop/cart/checkout' ) === -1 ) {
            sessionStorage.setItem( e4.settings.ecom.cart.storageKeyInternalBackLink, document.referrer );
        }
    },
    goToInternalBackLink: function ( event ) {
        var strInternalBackLink = sessionStorage.getItem( e4.settings.ecom.cart.storageKeyInternalBackLink );
        if ( strInternalBackLink !== null && strInternalBackLink.indexOf( location.protocol + '//' + location.host ) === 0 ) {
            event.preventDefault();
            location.href = strInternalBackLink;
        }
    },
    addProduct: function ( objProductFormData, fnCallback ) {
        var jDocument = jQuery( document ),
            jCart = jDocument.find( '.js-e-cart' );
        var objProductData = {
            CartCmd: 'add',
            ProductID: '',
            VariantID: '',
            Quantity: 1,
            Redirect: false
        };

        if ( jQuery.isPlainObject( objProductFormData ) === true ) {
            jQuery.extend( objProductData, objProductFormData );
        }
        else if ( jQuery.type( objProductFormData ) === 'string' ) {
            objProductData.ProductID = objProductFormData;
        }
        jDocument.trigger( e4.cart.event.productadd, objProductData );
        //console.log('Product ADD', alcadon.cart.currentProject)
        return e4.cart.ajax( {
            data: objProductData
        }, function ( jsonData ) {
            if ( jCart.length === 1 ) {
                e4.cart.updateContent( jsonData );
                if ( jQuery.isArray( jsonData.cart.lastAdded ) === true ) {
                    var objProductLastAdded = jsonData.cart.lastAdded[ jsonData.cart.lastAdded.length - 1 ],
                        strOrderlineId = e4.cart.orderline.getIdByProduct( objProductLastAdded );
                    e4.cart.orderline.setFocus( strOrderlineId );
                }
            }

            e4.cart.updateProjectInfo( jsonData.cart );
            e4.cart.updateQuantityInfo( jsonData.cart.productQuantity );
            if ( typeof fnCallback === 'function' ) {
                fnCallback( jsonData );
            }
            jDocument.trigger( e4.cart.event.productadded, jsonData );
            console.log( 'trigger', e4.cart.event.productadded );
        } );
    },
    removeProduct: function () {
    },
    updateContent: function ( jsonData ) {
        var jCart = jQuery( '.js-e-cart' );
        if ( jCart.length === 1 ) {
            jCart.trigger( e4.cart.event.update );
            jCart.find( '.js-e-cart-block-container[data-key="orderlines"]' ).html( jsonData.cart.orderlines );
            jCart.find( '.js-e-cart-block-container[data-key="orderSummery"]' ).html( jsonData.cart.orderSummery );
            jCart.find( '.js-e-cart-block-container[data-key="projectSelect"]' ).html( jsonData.cart.projectSelect );
            jCart.find( '.js-e-cart-block-container[data-key="deliveryDate"]' ).html( jsonData.cart.deliveryDate );
            jCart.find( '.js-e-cart-block-container[data-key="savedCarts"]' ).html( jsonData.cart.savedCarts );
            e4.cart.updateQuantityInfo( jsonData.cart.productQuantity );
            jCart.trigger( e4.cart.event.updated );
        }
    },
    updateQuantityInfo: function ( intQuantity ) {
        var jCartQuantity = jQuery( '.js-e-cart-quantity' );
        if ( jCartQuantity.length > 0 ) {
            if ( jQuery.isNumeric( intQuantity ) === false ) {
                e4.cart.ajax( {
                    method: 'GET'
                }, function ( jsonData ) {
                    if ( jQuery.isNumeric( jsonData.cart.productQuantity ) === true ) {
                        e4.cart.updateQuantityInfo( jsonData.cart.productQuantity );
                    }
                } );
            }
            else if ( intQuantity === 0 ) {
                jCartQuantity.empty();
            }
            else {
                jCartQuantity.html( intQuantity );
            }
        }
    },
    updateProjectInfo: function ( jsonCart ) {
        console.log( 'updateProjectInfo', jsonCart );
        if ( jsonCart.currentProject !== null ) {
            var jProjectList = jQuery( '.js-alcadon-project-list' );
            jQuery( '.js-alcadon-nav-project-name' ).text( jsonCart.currentProject.Name );
            if ( jProjectList.length > 0 ) {
                jProjectList.data( 'currentProject', jsonCart.currentProject.Name );
            }
        }
        else {
            jQuery( '.js-alcadon-nav-project-name' ).text( '' );
        }
    },
    orderline: {
        bindEvents: function () {
            jQuery( '.js-e-cart-form' ).on( 'focus blur', '.js-e-orderline-quantity-input', e4.cart.orderline.toggleFocus ).on( 'input', '.js-e-orderline-quantity-input', e4.util.debounce( function ( event ) {
                e4.cart.orderline.update( event.target );
            }, e4.settings.debounceDelay.input * 2 ) ).on( 'input', '.js-e-orderline-comment-input', e4.util.debounce( function ( event ) {
                e4.cart.orderline.saveComment( event.target );
            }, e4.settings.debounceDelay.input * 10 ) ).on( 'input', '.js-e-orderline-comment-input', function ( event ) {
                e4.cart.orderline.hideCommentHelpText( event.target );
            } ).on( 'click', '.js-e-orderline-update-btn', function ( event ) {
                event.preventDefault();
                e4.cart.orderline.update( event.target );
            } ).on( 'click', '.js-e-orderline-delete-btn', function ( event ) {
                event.preventDefault();
                e4.cart.orderline.delete( event.target );
            } );
        },
        update: function ( domNode ) {
            var jOrderline = jQuery( domNode ).closest( '.js-e-orderline' ),
                intOrderlineQuantity = parseInt( jOrderline.find( '.js-e-orderline-quantity-input' ).val() );
            if ( intOrderlineQuantity !== 0 ) {
                var jForm = jOrderline.closest( '.js-e-cart-form' ),
                    jCart = jForm.closest( '.js-e-cart' ),
                    intOrderlineQuantityOriginal = parseInt( jOrderline.data( 'product-quantity' ) );
                if ( intOrderlineQuantity > intOrderlineQuantityOriginal ) {
                    jCart.trigger( e4.cart.event.orderlineincrease );
                }
                else if ( intOrderlineQuantity < intOrderlineQuantityOriginal ) {
                    jCart.trigger( e4.cart.event.orderlinedecrease );
                }
                jForm.find( '.js-e-cart-form-cartcmd' ).val( 'updateorderlines' );
                e4.cart.ajax( {
                    data: jForm.serialize()
                }, function ( jsonData ) {
                    e4.cart.updateContent( jsonData );
                    e4.cart.updateProjectInfo( jsonData.cart );
                    e4.cart.orderline.setFocus( jOrderline.attr( 'id' ) );
                } );
            }
        },
        delete: function ( domNode ) {
            var jCart = jQuery( '.js-e-cart' ),
                jOrderline = jQuery( domNode ).closest( '.js-e-orderline' ),
                objOrderlineData = jOrderline.data();
            jCart.trigger( e4.cart.event.orderlinedelete );
            var objUpdate = {
                key: jOrderline.attr( 'id' ),
                CartCmd: 'delorderline',
                Redirect: false
            };
            if ( objOrderlineData.quoteContextId !== '' ) {
                objUpdate.OrderContext = objOrderlineData.quoteContextId;
            }
            e4.cart.ajax( {
                data: objUpdate
            }, function ( jsonData ) {
                e4.cart.updateContent( jsonData );
                e4.cart.updateProjectInfo( jsonData.cart );
                jCart.trigger( e4.cart.event.orderlinedeleted, {
                    currencyCode: jsonData.cart.currencyCode,
                    name: objOrderlineData.productName,
                    number: objOrderlineData.productNumber,
                    price: objOrderlineData.productPrice,
                    quantity: objOrderlineData.productQuantity
                } );
            } );
        },
        saveComment: function ( domInput ) {
            e4.cart.ajax( {
                data: [
                    domInput.name,
                    domInput.value
                ].join( '=' ),
                beforeSend: jQuery.noop
            }, function () {
                e4.cart.orderline.showCommentHelpText( domInput );
            } );
        },
        showCommentHelpText: function ( domInput ) {
            jQuery( domInput ).closest( '.form-group' ).find( '.js-e-orderline-comment-help-text' ).prop( 'hidden', false );
        },
        hideCommentHelpText: function ( domInput ) {
            jQuery( domInput ).closest( '.form-group' ).find( '.js-e-orderline-comment-help-text' ).prop( 'hidden', true );
        },
        setFocus: function ( strId ) {
            if ( strId !== '' ) {
                var jOrderline = jQuery( '.js-e-orderline' ).filter( '#' + strId );
                if ( jOrderline.length === 1 ) {
                    jOrderline.find( '.js-e-orderline-quantity-input' ).trigger( 'focus' );
                }
            }
        },
        getIdByProduct: function ( objProduct ) {
            var strReturnValue = '',
                jOrderline = jQuery( '.js-e-orderline' ).filter( '[data-product-id="' + objProduct.id + '"][data-product-variant-id="' + objProduct.variantId + '"]' );
            if ( jOrderline.length === 1 ) {
                strReturnValue = jOrderline.attr( 'id' );
            }
            return strReturnValue;
        },
        toggleFocus: function ( event ) {
            var jOrderline = jQuery( event.target ).closest( '.js-e-orderline' );
            if ( event.type === 'focusin' ) {
                jQuery( event.target ).select();
                jOrderline.addClass( 'has-focus' );
            }
            else {
                jOrderline.removeClass( 'has-focus' );
            }
        }
    },
    msg: {
        timeout: null,
        init: function () {
            if ( jQuery( '#js-e-cart-msg' ).length === 1 ) {
                e4.cart.msg.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery( document ).on( e4.cart.event.productadded, function ( event, jsonData ) {
                console.log( e4.cart.event.productadded );
                e4.cart.msg.build( jsonData );
                e4.cart.msg.show();
            } );
            jQuery( '#js-e-cart-msg' ).on( 'click', function ( event ) {
                if ( jQuery( event.target ).is( '#js-e-cart-msg' ) === true ) {
                    e4.cart.msg.hide();
                }
            } ).find( '.modal-dialog' ).on( 'mouseenter', e4.cart.msg.clearTimeout ).on( 'mouseleave', e4.cart.msg.setTimeout );
        },
        build: function ( jsonData ) {
            jQuery( '#js-e-cart-msg' ).find( '.js-e-cart-msg-content' ).html( jsonData.cart.lastAdded );
        },
        show: function () {
            e4.cart.msg.clearTimeout();
            e4.cart.msg.setPosition();
            jQuery( '#js-e-cart-msg' ).modal( 'show' );
            e4.cart.msg.setTimeout();
        },
        hide: function () {
            e4.cart.msg.clearTimeout();
            jQuery( '#js-e-cart-msg' ).modal( 'hide' );
        },
        setPosition: function ( objPosition ) {
            var jCartMsgDialog = jQuery( '#js-e-cart-msg' ).find( '.modal-dialog' ),
                jHeader = jQuery( '.js-e-header' ),
                jNavItemCart = jHeader.find( '.js-e-nav' ).find( '.js-e-nav-item-cart' ).filter( ':visible' ).first(),
                objCartMsgPosition = objPosition || {},
                objCartMsgReferencePosition = {};
            if ( jCartMsgDialog.length === 1 ) {
                if ( jQuery.isEmptyObject( objCartMsgPosition ) === true ) {
                    if ( jNavItemCart.length === 1 ) {
                        objCartMsgReferencePosition = jNavItemCart.get( 0 ).getBoundingClientRect();
                        objCartMsgPosition = {
                            top: jHeader.hasClass( 'is-hidden' ) === true ? '' : Math.floor( objCartMsgReferencePosition.bottom ),
                            right: Math.floor( jQuery( window ).width() - objCartMsgReferencePosition.right ),
                            left: '',
                            maxWidth: ''
                        };
                    }
                    else {
                        objCartMsgPosition = {
                            top: 0,
                            right: 0,
                            left: 0,
                            maxWidth: '100%'
                        };
                    }
                }
            }
            jCartMsgDialog.css( objCartMsgPosition );
        },
        setTimeout: function () {
            e4.cart.msg.clearTimeout();
            e4.cart.msg.timeout = setTimeout( e4.cart.msg.hide, e4.settings.ecom.cart.msgHideDelay );
        },
        clearTimeout: function () {
            if ( e4.cart.msg.timeout !== null ) {
                clearTimeout( e4.cart.msg.timeout );
                e4.cart.msg.timeout = null;
            }
        }
    }
};
